/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Premium_VoicesInputs */

const en_dialog_premium_voices = /** @type {(inputs: Dialog_Premium_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose from Premium Voices with Listening Premium`)
};

const es_dialog_premium_voices = /** @type {(inputs: Dialog_Premium_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige entre voces Premium con Listening Premium`)
};

/**
* | output |
* | --- |
* | "Choose from Premium Voices with Listening Premium" |
*
* @param {Dialog_Premium_VoicesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_voices = /** @type {((inputs?: Dialog_Premium_VoicesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_VoicesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_voices(inputs)
	return en_dialog_premium_voices(inputs)
});